import cookieHelper from 'js-cookie'
import store from '../store'
import { MessageBox } from 'element-ui'
import { ls } from './index'

export const TOKEN_KEY = 'login-token'

export function getCookie(key) {
  return cookieHelper.get(key)
}

export function setCookie(key, value) {
  return cookieHelper.set(key, value)
}

export function removeCookie(key) {
  return cookieHelper.remove(key)
}

export function getToken() {
  return getCookie(TOKEN_KEY)
}

export function setToken(token) {
  ls.setItem(TOKEN_KEY, token)
  return setCookie(TOKEN_KEY, token)
}

export function removeToken() {
  ls.removeItem(TOKEN_KEY)
  return removeCookie(TOKEN_KEY)
}

export function getAccessToken() {
  const query = window.location.hash.substring(1)
  const params = query.split('&')
  for (var i = 0; i < params.length; i++) {
    const [key, value] = params[i].split('=')
    if (key === 'access_token') return value
  }

  return false
}

export function toLogin() {
  const { origin, host, pathname } = window.location
  const redirectUri = process.env.NODE_ENV === 'production' && (host === 'tmecp-test.tencentmusic.com' || host === 'tmecp.tencentmusic.com')
    ? `${origin}?path=${pathname}`
    : `http://10.62.108.12:8080/?path=${pathname}&original_url=${origin}`

  const url = 'https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=101553571'
  const openUrl = url + `&redirect_uri=${encodeURIComponent(redirectUri)}`

  window.location.href = openUrl
}

// FIXME 因为统一登录需要注册一个主体为腾讯的QQ互联应用，但老的QQ登录用户openId是不一样的，所以要接两套登录
export function toLoginNew(type) {
  const { origin, host, pathname } = window.location
  const redirectUri = process.env.NODE_ENV === 'production' && (host === 'tmecp-test.tencentmusic.com' || host === 'tmecp.tencentmusic.com')
    ? `${origin}${pathname}?path=${pathname}&redirect_type=${type}`
    : `http://10.62.108.12:8080/?path=${pathname}&redirect_type=${type}&original_url=${origin}`

  const url = 'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=102107968&state=tmecp'
  const openUrl = url + `&redirect_uri=${encodeURIComponent(redirectUri)}`

  window.location.href = openUrl
}

/**
 * 返回格式化后的url params
 * @param {String} URL 地址，例如http://www.domain.com/?user=anonymous&id=123&id=456&city=%E5%8C%97%E4%BA%AC&enabled
 * @return {Object}    针对以上URL返回以下对象
 * {
  user: 'anonymous',
  id: [123, 456],     // 重复出现的 key 要组装成数组，能被转成数字的就转成数字类型
  city: '北京',        // 中文
  enabled: true,      // 未指定值的 key 约定值为 true
}
*/
export function getUrlParams(originUrl) {
  if (!originUrl) originUrl = window.location.href

  const url = decodeURIComponent(originUrl)
  const index = url.indexOf('?')
  if (index === -1) {
    return {}
  }

  const queryString = url.substr(index + 1)
  const queryArr = queryString.split('&')
  const queryObj = {}

  queryArr.forEach(item => {
    const itemArr = item.split('=')
    const key = itemArr[0]
    const value = itemArr[1]

    if (Array.isArray(queryObj[key])) {
      queryObj[key].push(value)
    } else if (queryObj[key]) {
      queryObj[key] = [queryObj[key], value]
    } else {
      queryObj[key] = value || true
    }
  })
  return queryObj
}

/**
 * 删除url中的某个参数
 * @param {String} URL 地址，例如http://www.domain.com/?user=anonymous&id=123&id=456&city=%E5%8C%97%E4%BA%AC&enabled
 * @param {String} key 指定的key
 * @return {String} URL 删除指定参数后的URL
 */
export function deleteUrlParams(key, url = window.location.href) {
  if (!key) return url
  const reg = new RegExp(`[\\&\\?]${key}=([^&]+)`, 'g')
  return url.replace(reg, '')
}

export async function loginByQQ(params) {
  try {
    await store.dispatch('Login', params)
    store.commit('login', false)
  } catch (e) {
    store.commit('login', false)
    MessageBox.alert(e.message, '异常', {
      type: 'error',
    })
  }
}

export async function loginByQQNew(params) {
  try {
    await store.dispatch('LoginNew', params)
    store.commit('login', false)
  } catch (e) {
    store.commit('login', false)
    MessageBox.alert(e.message, '异常', {
      type: 'error',
    })
  }
}

export function logout(homePath = '/index') {
  store.dispatch('LogOut').then(() => {
    //
  }).catch(error => {
    console.error(error)
  }).finally(_ => {
    if (window.location.pathname !== homePath) {
      window.location.href = homePath
    }
    setTimeout(() => {
      store.commit('login', true)
    }, 2000)
  })
}

/**
 * 重定向到酷狗登录页
 */
export function goKgLogin() {
  const host = 'https://activity.kugou.com/login/v-3db9f276/index.html'
  const href = window.location.href
  const redirectUrl = `${href}${href.includes('?') ? '&' : '?'}redirect_type=kg_bind`
  const params = {
    openappid: 10241,
    scope: encodeURIComponent('userinfo|vip'),
    responseType: 'code',
    url: encodeURIComponent(redirectUrl)
  }

  window.location.href = `${host}?${Object.entries(params).map(([key, value]) => `${key}=${value}`).join('&')}`
}
